import type { HubUpdateDto } from "@cede/types";
import { API_ENDPOINT, QueryKeys } from "@cede/utils";
import { useApi } from "@/hooks/core";
import { useQuery } from "@tanstack/react-query";

export const useHubUpdates = () => {
  const api = useApi();

  const { data, isLoading } = useQuery<HubUpdateDto[]>({
    queryKey: [QueryKeys.HUB_UPDATES],
    queryFn: async () => {
      return api.getOrThrow(API_ENDPOINT.HUB_UPDATES_PUBLISHED);
    },
    staleTime: 60_000,
    refetchInterval: 5 * 60_000,
    select: (updates) => {
      if (!updates) return [];
      // Already sorted by publishedAt desc from the API
      return updates;
    },
  });

  const updates = data ?? [];
  const latestPublishedAt = updates.length > 0 ? (updates[0]?.publishedAt ?? null) : null;

  return {
    updates,
    latestPublishedAt: latestPublishedAt ? new Date(latestPublishedAt).toISOString() : null,
    isLoading,
  };
};
